
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

const OrdersTableHeader = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="w-10"></TableHead>
        <TableHead>Receipt ID</TableHead>
        <TableHead>Customer</TableHead>
        <TableHead>Product(s)</TableHead>
        <TableHead>Address</TableHead>
        <TableHead>City</TableHead>
        <TableHead>Country</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Payment Method</TableHead>
        <TableHead>Net Revenue</TableHead>
        <TableHead>Total Price</TableHead>
        <TableHead>Date</TableHead>
        <TableHead>Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default OrdersTableHeader;
